interface IProps {
    width?: number;
    height?: number;
}

export const PlayIcon = (props: IProps) => {
    const {width, height} = props;
    return (<svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || 16}
        height={height || 17}
        viewBox="0 0 16 17"
        fill="none"
    >
        <path
            d="M4.66667 14.3138L13.3333 8.98049L4.66667 3.64716V14.3138Z"
            fill="#FCFCFC"
        />
    </svg>);
}